import { HugeiconsIcon } from "@hugeicons/react"
import { ArrowTurnBackwardIcon, ArrowTurnForwardIcon, Download04Icon } from "@hugeicons/core-free-icons"
import { useCompositorStore } from "@/lib/stores/compositor-store"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

const ZOOM_LEVELS = ["25%", "50%", "75%", "100%", "125%", "150%", "200%"]

export function CompositorToolbar() {
  const undo = useCompositorStore((s) => s.undo)
  const redo = useCompositorStore((s) => s.redo)
  const undoStack = useCompositorStore((s) => s.undoStack)
  const redoStack = useCompositorStore((s) => s.redoStack)
  const zoom = useCompositorStore((s) => s.zoom)
  const setZoom = useCompositorStore((s) => s.setZoom)
  const triggerExport = useCompositorStore((s) => s.triggerExport)

  const zoomPercent = `${Math.round(zoom * 100)}%`

  return (
    <div className="flex items-center justify-between px-4 py-2 border-t border-border/50 bg-background/50 h-10">
      {/* Left: export */}
      <div className="flex items-center gap-2">
        <button
          onClick={triggerExport}
          className="flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-md bg-accent hover:bg-accent/80 text-foreground transition-colors"
          title="Export as PNG at full resolution"
        >
          <HugeiconsIcon icon={Download04Icon} size={12} />
          Export PNG
        </button>
      </div>

      {/* Right: undo/redo + zoom */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <button
            onClick={undo}
            disabled={undoStack.length === 0}
            className="p-1.5 rounded hover:bg-accent disabled:opacity-30 transition-colors"
            title="Undo"
          >
            <HugeiconsIcon icon={ArrowTurnBackwardIcon} size={14} className="text-muted-foreground" />
          </button>
          <button
            onClick={redo}
            disabled={redoStack.length === 0}
            className="p-1.5 rounded hover:bg-accent disabled:opacity-30 transition-colors"
            title="Redo"
          >
            <HugeiconsIcon icon={ArrowTurnForwardIcon} size={14} className="text-muted-foreground" />
          </button>
        </div>

        <Select
          value={zoomPercent}
          onValueChange={(v) => setZoom(parseInt(v) / 100)}
        >
          <SelectTrigger className="h-7 w-20 text-[11px] border-border/50">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {ZOOM_LEVELS.map((level) => (
              <SelectItem key={level} value={level} className="text-[11px]">
                {level}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
